import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import Keycloak from 'keycloak-js';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-home',
  imports: [NgIf],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
  registerAvailable = environment.registerAvailable;

  constructor(
    private router: Router,
    private keycloak: Keycloak
  ) {}

  ngOnInit() {
    if (this.keycloak.authenticated) {
      this.router.navigate(['/dashboard']);
    }
  }

  agencyLogin(): void {
    this.keycloak.login({ redirectUri: window.location.origin });
  }

  agencyRegistration(): void {
    this.router.navigate(['/register']);
  }

  bpLogin(): void {
    window.open(environment.bpUrl, '_blank');
  }

  readDocs(): void {
    window.open('https://support.airgateway.com/', '_blank');
  }
}
